/**
 *  상품 공지사항 리스트 필터 옵션 모델
 */
export const NOTICE_PRODUCT_LIST_FILTER_OPTION_MODEL = {
  /**
   *  브랜드 명
   */
  storeName: null,
  /**
   *  상품 공지사항 상태
   */
  status: null,
  /**
   *  제목
   */
  title: null,
  /**
   *  내용
   */
  content: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  노출 기간
   */
  period: {
    startDate: null,
    endDate: null,
  },
  /**
   *  작성일
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
};

/**
 *  상품 공지사항 리스트 필터 옵션 모델
 */
export const NOTICE_PRODUCT_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  상품 공지사항 정보 모델
 */
export const NOTICE_PRODUCT_INFO_MODEL = {
  /**
   *  브랜드 명
   */
  storeName: null,
  /**
   *  브랜드 아이디
   */
  storeId: null,
  /**
   *  공지사항 상태
   */
  status: null,
  /**
   *  제목
   */
  title: null,
  /**
   *  본문
   */
  content: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  노출 기간
   */
  period: {
    startDate: null,
    endDate: null,
  },
};
